import type { ComponentType } from 'react';

export type UseWidget = <P extends {}>(
  componentId: string,
  options?: { skeletonClassName?: string },
) => ComponentType<P>;
